/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 * @author Maxim Fedorov
 * @author Yakov.Gushchin
 * @version 1.0.5
 * @since 1.0.5
 */

import { ColorGrey7, ColorWhite, FreshAsphalt50 } from './palette';

export const CalendarCellBgColor = ColorWhite;
export const CalendarCellColor = FreshAsphalt50;
export const WeekCellColor = ColorGrey7;
